var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenDuacolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.3742 7.26086C17.6785 6.95652 17.9198 6.59522 18.0845 6.19761C18.2491 5.79999 18.3339 5.37384 18.3338 4.94348C18.3338 4.51312 18.249 4.08698 18.0842 3.68939C17.9195 3.2918 17.6781 2.93056 17.3737 2.62627C17.0694 2.32199 16.7081 2.08063 16.3105 1.91597C15.9129 1.75131 15.4867 1.66659 15.0564 1.66663C14.1872 1.6667 13.3537 2.01205 12.7392 2.62669L12 3.36585L12.0317 3.45835C12.3961 4.50075 12.9925 5.44676 13.7758 6.22502C14.5772 7.03143 15.556 7.63927 16.6342 8.00002L17.3742 7.26086Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0324 3.33337L11.9999 3.36504L12.0315 3.45837C12.3959 4.50077 12.9923 5.44678 13.7757 6.22504C14.5771 7.03144 15.5559 7.63929 16.634 8.00004L9.5007 15.1334C9.01903 15.6142 8.7782 15.855 8.5132 16.0617C8.20026 16.3053 7.86191 16.5142 7.50403 16.685C7.2007 16.83 6.8782 16.9375 6.23236 17.1525L2.82986 18.2867C2.67416 18.3389 2.50701 18.3466 2.34717 18.309C2.18732 18.2714 2.04112 18.19 1.92497 18.0739C1.80882 17.9579 1.72732 17.8117 1.68962 17.6519C1.65191 17.4921 1.6595 17.3249 1.71153 17.1692L2.84653 13.7659C3.06153 13.1209 3.16903 12.7984 3.3132 12.495C3.48486 12.1362 3.69292 11.7995 3.93736 11.485C4.14403 11.22 4.38486 10.98 4.8657 10.4992L12.0324 3.33337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenDuacolor);
export default __webpack_public_path__ + "static/media/pen_duacolor.16ab6da67eb1b9cbde8385a48d20b2b4.svg";
export { ForwardRef as ReactComponent };